import { Dayjs } from 'dayjs';

import { Race, RaceEntryStatus } from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';

class RaceSelector {
  private race: Race;

  constructor(initialState: Race) {
    this.race = initialState;
  }

  get marginedOrderDeadline(): Dayjs {
    return this.race.orderDeadline.subtract(0, 's'); // デッドラインのマージンを10秒から0秒に更新
  }

  get isCanceled(): boolean {
    return (
      this.race.isCanceled ||
      [RaceEntryStatus.StopRace, RaceEntryStatus.StopHeld].includes(
        this.race.raceEntryStatus,
      )
    );
  }

  get isHeld(): boolean {
    return this.marginedOrderDeadline.isAfter(dayjst()) && !this.isCanceled;
  }
}

export const raceSelector = (race: Race) => {
  return new RaceSelector(race);
};
